import React, { PropsWithChildren } from "react";
import Grid from '@mui/material/Grid2';
import { Card, CardContent, Stack } from "@mui/material";

import SummaryRoom from "../SummaryRoom";
import { RoomTypeInterface } from "../../ListView/AssetCharacteristics";

import { SummaryRoomProps } from "../SummaryRoom";
import Deckboard from "@common/components/ListDetailViews/common/Deckboard";
import DeckboardIconButton, {
  DeckboardIconButtonProps,
} from "@common/components/ListDetailViews/common/Deckboard/DeckboardIconButton";
import { Fragment } from "react";
import Typography from "@common/components/Typography";
import { useTranslation } from "react-i18next";

export type LeftPanelProps = {
  roomInformation?: SummaryRoomProps;
  deckboardButtons?: DeckboardIconButtonProps[];
  roomTypes?: RoomTypeInterface[];
  configurationButton?: React.JSX.Element;
};
export const DateAssetsInfo = ({
  createdDate,
  lastUpdatedAt,
}: Pick<SummaryRoomProps, "lastUpdatedAt" | "createdDate">) => {
  const { t } = useTranslation();

  const renderDate = (label: string, date?: string) => (
    <Grid container spacing={2} sx={{ width: '100%' }}>
      <Grid size={6}>
        <Typography size="smaller">{t(label)}</Typography>
      </Grid>
      <Grid size={6}>
        <Typography
          size="smaller"
          sx={{
            fontWeight: 600,
          }}
        >
          {date}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <>
      {renderDate(t("Date Created:"), createdDate)}
      {renderDate(t("Date Last Updated:"), lastUpdatedAt)}
    </>
  );
};

const LeftPanel = (props: PropsWithChildren<LeftPanelProps>) => {
  const { deckboardButtons, roomInformation, configurationButton } = props;
  const lastLineCount =
    deckboardButtons === undefined
      ? 0
      : deckboardButtons.length % 4 === 0
      ? 4
      : deckboardButtons.length % 4;
  const hasEmptyLastRow = (buttons: DeckboardIconButtonProps[]) => {
    if (buttons.slice(-lastLineCount).every(({ hidden }) => hidden))
      return true;
    return false;
  };

  return (
    <Fragment>
      {roomInformation && deckboardButtons && (
        <Stack
          sx={[
            {
              maxWidth: "100%",
              width: "100%",
            },
            ({ palette }) => ({
              "& > .MuiPaper-root": {
                backgroundColor: palette.background.default,
                my: "1rem",
                border: `1px dotted ${palette.common.grey.light}`,
              },
              "& .MuiCardContent-root:last-child": {
                paddingBottom: 2,
              },
            }),
          ]}
        >
          <SummaryRoom
            {...roomInformation}
            configurationButton={configurationButton}
          />
          <Deckboard>
            {(hasEmptyLastRow(deckboardButtons ?? [])
              ? deckboardButtons.slice(0, -lastLineCount)
              : deckboardButtons
            )?.map((button, index) => {
              return <DeckboardIconButton {...button} key={index} />;
            })}
          </Deckboard>
          {(roomInformation.createdDate || roomInformation.lastUpdatedAt) && (
            <Card variant="outlined">
              <CardContent>
                <DateAssetsInfo
                  createdDate={roomInformation?.createdDate}
                  lastUpdatedAt={roomInformation?.lastUpdatedAt}
                />
              </CardContent>
            </Card>
          )}
          {props.children}
        </Stack>
      )}
    </Fragment>
  );
};

export default LeftPanel;
